import React, { useEffect, useState } from "react";
import "../styles.css";

type CoachMarkStepSixProps = {
  visible: boolean;
  onNext: () => void;
  targetSelector?: string;
};

const MAX_CARD_WIDTH = 380;

const CoachMarkStepSix = ({
  visible,
  onNext,
  targetSelector = ".coach-view-house-feed",
}: CoachMarkStepSixProps) => {
  const [position, setPosition] = useState({ top: 120, left: 12 });

  // Scroll to the target when step 6 becomes visible
  useEffect(() => {
    if (!visible) return;

    const target = document.querySelector(targetSelector) as HTMLElement | null;
    if (!target) return;

    requestAnimationFrame(() => {
      target.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    });
  }, [visible, targetSelector]);

  // Calculate and update card position based on target location
  useEffect(() => {
    if (!visible) return;

    const updatePosition = () => {
      const target = document.querySelector(targetSelector) as HTMLElement | null;

      if (!target) {
        setPosition({ top: 120, left: 12 });
        return;
      }

      const rect = target.getBoundingClientRect();
      const effectiveCardWidth = Math.min(MAX_CARD_WIDTH, window.innerWidth - 24);
      // try to place above the feed
      const desiredTopAbove = rect.top - 172;
      // fallback to below if not enough space
      const desiredTopBelow = rect.bottom + 8;
      const topCandidate = desiredTopAbove >= 12 ? desiredTopAbove : desiredTopBelow;
      const maxTop = Math.max(12, window.innerHeight - 200);
      const desiredLeft = rect.left;
      const maxLeft = Math.max(12, window.innerWidth - effectiveCardWidth - 12);

      setPosition({
        top: Math.max(12, Math.min(topCandidate, maxTop)),
        left: Math.max(12, Math.min(desiredLeft, maxLeft)),
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [targetSelector, visible]);

  if (!visible) return null;

  return (
    <div
      className="coachmark-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Coach mark step six"
    >
      <div
        className="coachmark-step-six-card"
        style={{ top: `${position.top}px`, left: `${position.left}px` }}
      >
        <div className="coachmark-step-six-content">
          <img
            src={require("../../assets/coachViewBlackLogo.png")}
            alt=""
            aria-hidden="true"
            className="coachmark-step-six-logo"
          />
          <div className="coachmark-step-six-text-wrap">
            <div className="coachmark-step-six-text">
              The feed is <span className="coachmark-step-six-emphasis">private</span> to our house
            </div>
            <div className="coachmark-step-six-text">only and where we can be uniquely</div>
            <div className="coachmark-step-six-text">ourselves. Just one last thing!</div>
          </div>
        </div>

        <div className="flex justify-center items-center">
            <button
            type="button"
            onClick={onNext}
            className="coachmark-step-six-next"
            aria-label="Go to house pledge"
            >
            <span>GO TO HOUSE PLEDGE</span>
            <img
                src={require("../../assets/arrow-left-coach.png")}
                alt=""
                aria-hidden="true"
                className="coachmark-step-six-next-icon"
            />
            </button>
        </div>
        
      </div>
    </div>
  );
};

export default CoachMarkStepSix;